<template>
    <div>
        <div class="main pb-4">

            <div class="text-center" v-if="!isTableOrderAddItem">
                <h3 v-if="tableOrderInfo.orderStatus !== 1">
                    <span v-if="tableOrderInfo.orderStatus === 2">訂單已取消</span>
                    <span v-else-if="tableOrderInfo.orderStatus === 3">訂單已作廢</span>
                </h3>
                <!--todo 已結帳出現-->
                <template v-if="tableOrderInfo.isCheckout && tableOrderInfo.orderStatus === 1">
                    <img src="../../assets/images/dialog_complete.gif" class="fixed-w-80">
                    <h3 class="mt-3">取餐確認頁請勿關閉</h3>
                </template>
                <h2 class="yellow">#{{tableOrderInfo.takeoutSerialNumber}}</h2>
                <b v-if="tableOrderInfo.orderCompleteText !== '' && tableOrderInfo.orderStatus === 1">{{tableOrderInfo.orderCompleteText}}</b>
            </div>

            <div class="list-style2">

                <div class="content" :key="isPayIndex">
                    <div class="d-flex">
                        <div class="add flex-grow-1">
                            {{ isTableOrderAddItem ? "建單" : "點餐"}}時間 {{tableOrderInfo.workedAt}}<br>
                            {{tableOrderInfo.adult}}位大人 {{tableOrderInfo.child}}位小孩<br>
                            桌號 {{tableOrderInfo.tableNo}}<br>
                            付款方式 : {{ ($public.notNull(tableOrderInfo.payment) && tableOrderInfo.payment.length > 0) ? `${tableOrderInfo.payment[0].name}${ ($public.notNull(tableOrderInfo.payment[0].cardNumber) && tableOrderInfo.payment[0].cardNumber !== "") ? ` (${tableOrderInfo.payment[0].cardNumber})` : ""}` : "現金"}}
                        </div>
                        <div class="right">
                            <p class="type red" v-if="!tableOrderInfo.isCheckout && tableOrderInfo.orderStatus === 1">待付款</p>
                            <p class="type green" v-else-if="tableOrderInfo.isCheckout && tableOrderInfo.orderStatus === 1">已結帳</p>
                            <p class="type" v-else-if="tableOrderInfo.orderStatus === 2 || tableOrderInfo.orderStatus === 3">{{ !tableOrderInfo.isCheckout ? "已取消" : "已退款" }}</p>
                            <b class="red">$ {{ isTableOrderAddItem && !tableOrderInfo.isCheckout ? tableOrderInfo.totalPrice : tableOrderInfo.invoicePrice}}</b>
                        </div>
                    </div>
                </div>

                <div class="d-flex w-100 mt-2">
                    <img src="../../assets/images/table-order-phone.svg" class="mr-2 fixed-w-20">
                    <div class="flex-grow-1">{{tableOrderInfo.phone}}</div>
                </div>
            </div>

            <!--todo 只有店內付款才出現此區塊，結帳成功和訂單取消此區塊也消失-->
            <div class="by-cash-reminder" v-show="isShowPaymentQRCodeBtn()" :key="qrcodeBtnKey">
                <div class="mt-4 mb-2 title">請於{{getPaymentDeadline()}}前至店內結帳完成</div>
                <p class="red">
                    需至櫃檯或自助點餐機付款完成後<br>
                    店家才會開始製作餐點</p>
                <el-button type="warning" round @click="clickShowQRCode()">
                    <img src="../../assets/images/qrcode2.svg" class="mr-2"/>顯示結帳QR CODE
                </el-button>
                <div class="shadow-line mt-4 m-0"/>
            </div>

            <!--todo 待處理區塊-->
            <div class="top-cart-list" v-if="pendingList.length > 0">
                <h4>
                    我的訂單
                    <span class="blue">待處理</span>
                </h4>
                <meal v-for="(recordItem,index) in pendingList" :recordItem="recordItem" :key="'pendingList'+index" :index="index"/>
                <div class="shadow-line m-0"/>
            </div>

            <!--todo 已取消區塊-->
            <div class="top-cart-list" v-if="cancelList.length > 0">
                <h4>
                    我的訂單
                    <span class="red">已取消</span>
                </h4>
                <meal v-for="(recordItem,index) in cancelList" :recordItem="recordItem" :key="'cancelList'+index" :index="index"/>
                <div class="shadow-line m-0"/>
            </div>

            <!--todo 已接受區塊-->
            <div class="top-cart-list">
                <h4>
                    我的訂單
                    <span v-if="isTableOrderAddItem">已接受</span>
                </h4>
                <meal v-for="(recordItem,index) in tableOrderInfo.orderList" :recordItem="recordItem" :key="index" :index="index"/>
            </div>

            <div class="cart-list no-after" v-if="isTableOrder || tableOrderInfo.isCheckout">
                <el-divider class="mt-0 mb-2"></el-divider>
                <div class="li">
                    小計
                    <span class="float-right">$ {{ tableOrderInfo.totalPrice }}</span>
                </div>
                <div class="li" v-if="tableOrderInfo.tip > 0">
                    服務費
                    <span class="float-right">$ {{ tableOrderInfo.tip }}</span>
                </div>
                <div v-for="(couponItem,couponIndex) in tableOrderInfo.discount" :key="couponIndex" class="li">
                    {{ couponItem.name }} {{ '(X' + couponItem.amount + ')' }}
                    <span class="float-right red">{{(couponItem.couponType === "freebie" || couponItem.couponType === "reserveFreebie" ? "" : (couponItem.couponType === "addPurchase" ? "+" : "-"))}} $ {{couponItem.totalPrice}}</span>
                </div>
                <div v-for="(item,index) in tableOrderInfo.otherDiscount" :key="index+'other'" class="li">
                    <span>{{ item.name || "手動折價" }}
                        <span class="float-right red">- $ {{ item.price }}</span>
                    </span>
                </div>
                <div v-for="(item,index) in tableOrderInfo.useRewardPointList" :key="index+'useRewardPoint'">
                    <span class="count">{{ item.name }} (X{{item.usePoint}}點)
                    <span class="float-right red"> - $ {{ item.amount }}</span>
                </span>
                </div>
                <div v-if="tableOrderInfo.buyerBan" class="li">
                    統一編號
                    <span class="float-right">{{ tableOrderInfo.buyerBan }}</span>
                </div>

                <el-divider class="mt-0 mb-2"></el-divider>
                <div class="li">
                    總計(含稅)
                    <span class="float-right red">$ {{ tableOrderInfo.invoicePrice }}</span>
                </div>
                <template v-if="tableOrderInfo.customerNote">
                    <el-divider class="mt-2 mb-3"></el-divider>
                    <h4>備註</h4>
                    <div>
                        {{ tableOrderInfo.customerNote }}
                    </div>
                </template>
            </div>

            <comm-dialog :value="isShowQrcodeDialog" :outerContent="qrcodeDialogOuterContent" :isCancel="false"  positiveLabel="關閉"
                         :isIcon="isIcon" :isQrcode="isQrcode" :qrcodeSrc="qrcodeSrc"
                         @result="onCommDialogClose"
            />

            <cart-button v-if="!closeBtn" toCart :message="'返回菜單頁面'" :closeBtn="true"/>

            <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>
    </div>

</template>

<script>
    import Meal from '@/views/order/components/Meal'
    import CommDialog from '@/components/CommDialog.vue';
    import * as constDefine from "@/store/constDefine";
    import CartButton from '@/views/order/components/CartButton';
    export default {
        name: "TableOrderComplete",
        components: {
            Meal,//餐點
            CommDialog,
            CartButton
        },
        data() {
            return {
                isLoading: false,
                isShowQrcodeDialog: false,          //是否顯示QRCode dialog
                qrcodeDialogOuterContent: "",       //QRCode dialog 相關參數
                isIcon: false,                      //QRCode dialog 相關參數
                isQrcode: true,                     //QRCode dialog 相關參數
                qrcodeSrc: "",                      //QRCode dialog 相關參數，qr code 內容
                qrcodeBtnKey: 0,                    //是否顯示結帳按鈕
                isPayIndex: 0,                      //畫面更新用
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
                tableOrderInfo: {
                  storeName: "",
                  takeoutSerialNumber: "",
                  workedAt: "",
                  isCheckout: false,
                  adult: 0,
                  child: 0,
                  tableNo: "",
                  invoicePrice: "",
                  phone: "",
                  orderList: [],
                  orderCompleteText: "",
                },
                isTableOrderAddItem: false,
                orderId: 0,
                pendingList: [],
                cancelList: [],
                isFirst: true,
                isTableOrder: false,
                closeBtn: true, //顯示關閉俺鈕
            }
        },
        created() {
          let close = sessionStorage.getItem("closeBtn");
          this.closeBtn = close !== null && close === "false" ? false : true;

          try {
            this.dataObject = this.$crypto.uriComponentToObject(this.dataToken);
            this.callSetupData();
          } catch (e) {
            this.$router.push({name:'Error'});
            return false;
          }
        },
        beforeRouteLeave: function (to, from, next) {
            if (to.name === "OrderCart" || (sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken) === null)) {
                if (typeof this.dataObject.prototypeObject !== "undefined") {
                    this.dataObject = {
                        ...this.dataObject.prototypeObject,
                        "prototypeObject": {...this.dataObject.prototypeObject},
                    }
                    sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(this.dataObject));
                }

                if (this.dataObject.routePath) {
                    this.$router.push({path: this.dataObject.routePath});
                } else {
                    this.$router.push({name: 'Error'});
                }
            } else if (to.name === "TableOrder" && this.isFirst === true) {
                this.isFirst = false;
                this.$router.push({name: to.name, query: {dataToken: to.query.dataToken}});
            } else {
                next();
            }
        },
        methods: {
            callSetupData() {
                if (this.dataObject.usedType === constDefine.QRCodeUsedType.TableOrderAddItem) {
                    this.isTableOrderAddItem = true;
                    this.orderId = this.dataObject.orderId;
                    this.setupDataFromOrderId();
                } else {
                    this.isTableOrder = true;
                    this.setupData();
                }
            },

          setupData() {
            this.isLoading = true;
            this.$http.fetch`GetTableOrder${{
              takeoutId:  this.dataObject.takeoutId,
              storeId:    this.dataObject.storeId,
            }}
          ${json => {
              if (json.status) {
                this.tableOrderInfo = json.data;
                this.tableOrderInfo.storeName = (json.data.storeName !== "" && json.data.storeName !== " " ? json.data.brandName + " " + json.data.storeName : json.data.brandName);
                this.isPayIndex++;
                this.qrcodeBtnKey++;

              } else {
                this.$public.showNotify(json.message, json.status);
              }
              this.isLoading = false;
            }}`;
          },
          setupDataFromOrderId() {
              this.isLoading = true
              this.$http.fetch`GetTableOrderFromOrderId${{
                  orderId:      this.orderId,
                  storeId:      this.dataObject.storeId,
              }}
              ${json => {
                  if (json.status) {
                      //有傳入的值才修改，否則就是原值
                      this.tableOrderInfo = {...this.tableOrderInfo, ...json.data};
                      this.pendingList = json.data.pendingList;
                      this.cancelList = json.data.cancelList;
                      this.tableOrderInfo.storeName = (json.data.storeName !== "" && json.data.storeName !== " " ? json.data.brandName + " " + json.data.storeName : json.data.brandName);
                      this.isPayIndex++;
                      this.qrcodeBtnKey++;
                  } else {
                      this.$public.showNotify(json.message, json.status);
                  }
                  this.isLoading = false;
              }}`;
          },

            /** 點擊顯示結帳QRCode按鈕 */
            clickShowQRCode() {
                //this.orderSn
                this.showQRCodeModal(this.tableOrderInfo.orderId, 0, this.dataObject.storeId);
            },

            /** 顯示結帳QRCode */
            isShowPaymentQRCodeBtn() {
                //這邊判斷的是 order 的 Status，訂單狀態(1:正常 2:取消 3:作廢)
                if (this.$public.notNull(this.tableOrderInfo.orderStatus) &&
                    this.tableOrderInfo.orderStatus === 1) {
                    if (this.$public.notNull(this.tableOrderInfo.isCheckout)) {
                        if (!this.isTableOrderAddItem) {
                            return !this.tableOrderInfo.isCheckout;
                        }
                    }
                }
                return false;
            },

            /** 取得結帳期限 */
            getPaymentDeadline() {
                if (this.$public.notNull(this.tableOrderInfo.workedAt)) {
                    //用date轉換 yyyy-mm-dd時間格式時，要把 '-' 轉換成 '/' ，不然在 ios會出現 NaN轉換錯誤
                    let workedAt = new Date(this.tableOrderInfo.workedAt.replace(/-/g, '/'));
                    workedAt.setMinutes(workedAt.getMinutes()+30);
                    return this.$public.dateFormat("hh:mm", workedAt);
                } else {
                    return "";
                }
            },

            /** 顯示結帳QRCode */
            showQRCodeModal(orderId, tableId, storeId) {
                let self = this;
                //QRCode頁面資訊
                // self.tableQRCodeSetting.qrcodeText = tableNo;
                //要顯示的加密 QRCode 參數內容
                let dataToken = this.$crypto.objectToURIComponent({
                    "orderId": orderId,
                    "tableId": tableId,
                    "storeId": Number(storeId),
                    // "merchantType": constDefine.MerchantType.Store,
                    // "usedType": constDefine.QRCodeUsedType.TableOrderAddItem,
                    "tableOrderRoutePath": "/table-order/storeCode",
                })
                //console.log(this.$crypto.uriComponentToObject(dataToken))
                // self.$store.commit(mutationTypes.setQRCodeData, {
                //     "name": tableNo,
                //     "isShowBrandInfo":true,
                //     "brandInfo":this.brandName+" "+this.storeName,
                //     "params": process.env.VUE_APP_OINAPP_HOST + "order?dataToken=" + dataToken,
                // });

                self.qrcodeSrc = process.env.VUE_APP_OINAPP_HOST + "order?dataToken=" + dataToken ;
                self.qrcodeDialogOuterContent =  '付款 QRCode';
                self.isShowQrcodeDialog = true;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.isShowQrcodeDialog = false;
                this.callSetupData();
            },
        },
        watch:{

        }
    }
</script>
<style lang="less" scoped src="../../less/order.less"/>
<style lang="less" scoped src="../../less/tableOrder.less"/>